import { Section } from "../styled/Containers.style";
import { LFooter, LFooterLink } from "../styled/Footer.style";
import { LSimpleText } from "../styled/Text.style";

export interface LinearFooterProps {
    inverted?: boolean
}

const LinearFooterCmp = ({ inverted = false }) => {
    return (
        <LFooter $inverted={inverted}>
            <Section linear 
                className="first-footer-section" $inverted={inverted}>
                <LFooterLink $inverted={inverted} href="https://www.linear.it/privacy" target="_blank">Privacy</LFooterLink>
                <LFooterLink $inverted={inverted} href="https://assicurazione.linear.it/cookie/" target="_blank">Cookie</LFooterLink>
            </Section>
            <LSimpleText $inverted={inverted}>
                Linear assicurazioni società di <strong style={{ color: inverted ? "white" : "#3C7B35" }}>Unipol Assicurazioni S.p.A.</strong>, CF 04260280377 - P.IVA 03740811207
            </LSimpleText>
        </LFooter>
    );
};

export default LinearFooterCmp;
